import React, { Suspense, lazy, useEffect, useState } from "react";
import CustomTable from "../components-bootstrap/CustomTable";
import { useGetFetch, useUpdateFetch, useUpdateForm } from "../../data/Queries";
import Loader from "../ui/Loader";
import Modal from "react-modal";
import Select from "react-select";
import { toast } from "react-toastify";
// import { AiOutlinePlus } from "react-icons/ai";
// import { BiSolidEdit } from "react-icons/bi";
import Pagination from "../../data/PaginationModified";
// import { AiFillDelete } from "react-icons/ai";
// import { AiOutlineClose } from "react-icons/ai";
import { formatDate, formatNumber } from "../../utils/utilityfunc";
import Tabs from "../ui/Tabs";
import "../../styles/centralised-plan/layouts.css";
import { useSelector } from "react-redux";
import { selectToken, selectUser } from "../auth/auth.selector";
import ModalHeader from "../ModalHeader.jsx";
import { plans_delete } from "../../data/ApiEndpoints.js";
import Icons from "../ui/Icons.jsx";
import AddFeature from "./AddFeature.jsx";
import HelmetWrapper from "../../HelmetWrapper.js";
import AllAccessCategories from "../all-access-categories/AllAccessCategories.jsx";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose.jsx";
import DetailListings from "./details/DetailListings.jsx";
// import COfferSystem from "../centralised-offer/COfferSystem.jsx";
// import Icons from "../ui/Icons.jsx";

const Addon = lazy(() => import("./Addon"));
const GoalFocusForm = lazy(() => import("./GoalFocusForm"));
const AddPlan = lazy(() => import("./AddPlan"));
const IncentiveModel = lazy(() => import("./IncentiveModel.jsx"));
const Offers = lazy(() => import("./Offers"));

export const plan_url = "/plan";
export const mapAblePlansDataKey = "mapAblePlansData";
export const add_plans = "/plan/draft/add";
export const plans_get = "/plan/draft/all";
export const plans_get_rg = "/plan/draft/all?is_goal=0";
export const update_plans = "/plan/draft/update";
export const plans_key = "plans";
export const workout_package = "/workoutpackage/mobile?workout_exp_id";
export const workout_packages_key = "workoutpackages";
export const workout_packages2_key = "workoutpackages2";
export const wp_gf_url = "/plan/bulk";
export const workout_package_gf = "/workoutpackage/featured";
export const workout_package_put = "/workoutpackage/update";

export const plan_draft_url = "/plan/add";
export const plan_draft_url_2 = "/plan/update";
// export const plans_gf_url = "";

const Plans = () => {
  const token = useSelector(selectToken);
  const userInfoData = useSelector(selectUser);

  const tabs = ["Regular", "Addons", "PT Incentive", "Offers"];
  const [formModal, setFormModal] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [mapUpdateModal, setMapUpdateModal] = useState({
    status: false,
    data: null,
  });
  const [search, setSearch] = useState("");
  const [currentPlan, setCurrentPlan] = useState(null);
  const [descModal, setDescModal] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [isMapModalOpenGF, setIsMapModalOpenGF] = useState(false);
  const [isEditModalOpenGF, setIsEditModalOpenGF] = useState(false);
  const [isFeatureModal, setIsFeatureModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [isPage, setIsPage] = useState(0);
  // const [isPageGF, setIsPageGF] = useState(0);
  const [filterGFMap, setFilterGFMap] = useState({});
  const {
    data: gfMapPlansData,
    refetch: refetchgfmapplans,
    isLoading: isLoadingGFPlDetail,
    isFetching: isFetchingGFPlDetail,
  } = useGetFetch({
    token,
    key: "plantomapgoalfocus",
    url: `${plan_url}/goal`,
    filters: filterGFMap,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    is_goal: "0",
  });
  const {
    data: plansData,
    isLoading: isLoadingPl,
    isFetching: isFetchingPl,
    refetch: refetchPlans,
  } = useGetFetch({
    token,
    filters,
    isPage: isPage + 1,
    key: plans_key,
    url: plans_get,
  });
  const {
    data: mapAblePlansData,
    isLoading: isLoadingmapPl,
    isFetching: isFetchingmapPl,
    refetch: refetchP,
  } = useGetFetch({
    token,
    filters: {
      status: "active",
      is_goal: "0",
    },
    key: mapAblePlansDataKey,
    limit: 100,
    url: plan_url,
  });
  const { mutateAsync: updatePlan, isLoading: isLoadingMapUpdate } =
    useUpdateForm({
      key: plans_key,
      url: update_plans,
      token,
    });
  const {
    data: wp_gf_data,
    refetch: refetchGFPlans,
    isLoading: isLoadingWP_GF,
    isFetching: isFetchingWP_GF,
  } = useGetFetch({
    token,
    // isPage: isPageGF + 1,
    key: workout_packages2_key,
    url: workout_package_gf,
  });

  const { mutateAsync: deletePlan, isLoading: isLoadingDltPlan } =
    useUpdateFetch({
      url: plans_delete,
      key: mapAblePlansDataKey,
      token,
    });

  const { mutateAsync: mapUpdatePlan, isLoading: isLoadingUMap } =
    useUpdateForm({
      token,
      key: "plans_update",
      url: plan_draft_url_2,
    });

  useEffect(() => {
    try {
      if (refetchPlans) {
        refetchPlans();
      }
    } catch (error) {
      console.log(error);
    }
  }, [isPage, filters]);

  function getMappedGyms(uid) {
    try {
      if (activeTab === tabs[4] && gfMapPlansData?.status) {
        const data = gfMapPlansData?.data;
        return data;
      }
      if (uid && mapAblePlansData && mapAblePlansData?.data?.length > 0) {
        const data = mapAblePlansData?.data?.filter(
          (plan) => plan?.package_details === uid
        );
        return data;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleMappedPlanDelete(uid) {
    try {
      if (window.confirm("Do you want to delete this Plan ?")) {
        const { status, message } = await deletePlan({
          data: { uid },
        });
        if (status) {
          toast.success(message ? message : "Deleted!");
        } else {
          toast.error(message ? message : "Server Error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleMappedPlanUpdate(row) {
    try {
      const mappingDetails = [
        {
          uid: row?.uid,
          plan_type: row?.plan_type,
          package_details: currentPlan?.uid,
        },
      ];
      const data = new FormData();
      data.append("centralized_map", "true");
      data.append("mapping_details", JSON.stringify(mappingDetails));
      const { status, message } = await mapUpdatePlan({ data });
      if (status) {
        refetchP();
        setMapUpdateModal({ status: false, data: null });
        toast.success(message ? message : "Updated!");
      } else {
        toast.error(message ? message : "Server Error");
      }
    } catch (error) {
      console.log(error);
    }
  }

  function editModalToggle(plan) {
    try {
      if (isEditModalOpen) {
        setCurrentPlan(null);
      } else {
        setCurrentPlan(plan);
      }
      setIsEditModalOpen(!isEditModalOpen);
    } catch (error) {
      console.log(error);
    }
  }

  function calcTax(action) {
    try {
      if (isNaN(action?.value)) return 0;
      const tax = (Number(action?.value) * 18) / 100;
      switch (action?.type) {
        case "tax":
          return tax;
        case "total":
          const total = Number(action?.value) + tax;
          return total;
        case "tax_inclusive":
          const taxInclusive = Math.round(
            (Number(action?.value) / 1.18) * 0.18
          );
          return taxInclusive;
        case "tax_exclusive":
          const exclusive = Math.round(Number(action?.value) * 1.18);
          return exclusive;
        case "selling_price":
          const pregst = Math.round(Number(action?.value) / 1.18);
          return pregst;
        default:
          return;
      }
    } catch (error) {
      console.log("🚀 calcTax ~ error", error);
    }
  }

  async function handleDelete(values) {
    try {
      if (window.confirm("MAPPED PLANS WILL ALSO BE MARKED INACTIVE.")) {
        const data = new FormData();
        const prices = values.price_details.map((detail) => {
          return {
            added_price: calcTax({
              type: "selling_price",
              value: detail.final_selling_price,
            }),
          };
        });
        const plan_price = {
          data: prices,
          type: "regular",
        };
        const form = {
          uid: values.uid,
          draft_offer_id: values.draft_offer_id,
          plan_name: values.plan_name,
          price: values.base_price,
          original_price: values.base_price,
          tax_percentage: 0.0,
          status: "deleted",
          diet_category_id: values.diet_category_id,
          duration: values.duration,
          description: values.description,
          is_recomended: 0,
          is_goal: values.plan_type === "goal_focus" ? 1 : 0,
          is_partial: 0,
          trainer_id: values.trainer_id,
          package_id: values.workout_package,
          plan_price: JSON.stringify(plan_price),
        };
        const keys = Object.keys(form);
        keys.forEach((key) => {
          data.append(key, form[key] || 0);
        });
        const { status } = await updatePlan({
          data,
        });
        if (status) {
          toast.success("Plan is deleted successfully!", { autoClose: 1500 });
        } else {
          toast.error("Error in deleting plan!", { autoClose: 1500 });
        }
        refetchPlans();
      }
    } catch (error) {
      console.log(error);
    }
  }

  function toggleFormModal() {
    setFormModal(!formModal);
  }

  // ------------- MODAL ---------------
  function toggleMapModal(plan) {
    try {
      if (isMapModalOpen) {
        setCurrentPlan(null);
      } else {
        setCurrentPlan(plan);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsMapModalOpen(!isMapModalOpen);
    }
  }

  function toggleMapModalGF(plan) {
    try {
      if (isMapModalOpenGF) {
        setCurrentPlan(null);
      } else {
        setCurrentPlan(plan);
      }
      setIsMapModalOpenGF(!isMapModalOpenGF);
    } catch (error) {
      console.log(error);
    }
  }

  function toggleFeatureModal(row) {
    try {
      setRowData(row);
    } catch (error) {
      console.log(error);
    } finally {
      setIsFeatureModal(!isFeatureModal);
    }
  }

  function toggleEditModalGF(plan) {
    try {
      if (isEditModalOpenGF) {
        setCurrentPlan(null);
      } else {
        setCurrentPlan(plan);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsEditModalOpenGF(!isEditModalOpenGF);
    }
  }

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onOpenModal = (name, row) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: name,
      rowData: row,
    }));
  };
  // ----------- XXXXXXXXX MODAL XXXXXXXXX ---------------

  function isdata() {
    try {
      if (activeTab === tabs[4]) {
        return wp_gf_data?.data?.length > 0;
      }
      return plansData?.data?.length > 0;
    } catch (error) {
      console.log(error);
    }
  }

  function getPagination() {
    try {
      const pagination = plansData?.pagination ? plansData?.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  function toggleDescModal(row) {
    try {
      if (descModal) {
        setCurrentPlan(null);
      } else {
        if (activeTab === tabs[4]) {
          setFilterGFMap({ package_id: row?.package_id });
        }
        setCurrentPlan(row);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDescModal(!descModal);
    }
  }

  function handleSearch(e) {
    try {
      const text = e.target.value;
      setSearch(text);
    } catch (error) {
      console.log(error);
    }
  }

  function applySearch() {
    try {
      if (search !== filters?.name) {
        setFilters((prev) => ({ ...prev, name: search }));
        setIsPage(0);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function resetSearch() {
    try {
      if (filters?.name) {
        setSearch("");
        setFilters((prev) => ({ ...prev, name: "" }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  function reOrder() {
    try {
      if (plansData?.data?.length > 0) {
        const data = plansData?.data?.sort((a, b) => {
          return Number(b?.date_added) * 1000 - Number(a?.date_added) * 1000;
        });
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      refetchgfmapplans();
    } catch (error) {
      console.log(error);
    }
  }, [filterGFMap]);

  const columns = [
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (data) => <span className="tb-data">{data}</span>,
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {!isNaN(row?.price) ? `₹${formatNumber(row?.price)}` : "N/A"}
          </span>
        );
      },
    },
    // {
    //   dataField: "date_added",
    //   text: "Date Added",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {formatDate(new Date(Number(row?.date_added) * 1000))}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "package_name",
      text: "Package Name",
      formatter: (data) => <span className="tb-data">{data}</span>,
    },
    {
      dataField: "",
      text: "Mapped Plans",
      formatter: (_, row) => {
        const length = getMappedGyms(row?.uid)?.length;
        return (
          <span
            onClick={() => toggleDescModal(row)}
            className="table-link-k tb-data fs-normal-k"
          >
            {length || "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "allaccess_category_name",
    //   text: "All Access Pass",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.is_allgym_access ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //         <br />
    //         {row?.allaccess_category_name || ""}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "is_new",
    //   text: "Is New",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.is_new ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "is_partial",
    //   text: "Is Partial",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.is_partial ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-check-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#209216" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "first_emi_percentage",
    //   text: "EMI percentag",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth150">
    //         {row?.first_emi_percentage || 0}/{row?.first_emi_percentage || 0}/
    //         {row?.first_emi_percentage || 0} (%)
    //         <br />
    //         <small>
    //           {row?.second_emi_duration || 0}/{row?.second_emi_duration || 0}{" "}
    //           (Days)
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "first_emi_percentage",
    //   text: "First EMI percentag",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">{row?.first_emi_percentage || 0}%</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "second_emi_percentage",
    //   text: "Second EMI",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth150">
    //         {row?.second_emi_percentage || 0}% <br />
    //         (Within {row?.second_emi_duration || 0} Days)
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "third_emi_percentage",
    //   text: "Third EMI",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data tb-data minWidth150">
    //         {row?.third_emi_percentage || 0}% <br /> (Within{" "}
    //         {row?.second_emi_duration || 0} Days)
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "fd_link_allowed",
    //   text: "Partial Allowed In A Month",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.fd_link_allowed || 0}</span>;
    //   },
    // },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const isActive = row?.status === "active";
        return (
          <div className="tb-data">
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "details",
      text: "View Details",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#000"
                className="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </button>
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="flex-k gap-05-k">
            <button
              onClick={() => editModalToggle(row)}
              className="btn-k btn-muted-k dark-text small"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-pencil-fill"
                viewBox="0 0 16 16"
              >
                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg>
              {/* <BiSolidEdit size={25} /> */}
            </button>
            <button
              onClick={() => handleDelete(row)}
              disabled={isLoadingMapUpdate}
              className="btn-k btn-muted-k dark-text small"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
              {/* <AiFillDelete size={25} /> */}
            </button>
            <button
              onClick={() => toggleMapModal(row)}
              className={"btn-k btn-muted-k dark-text small"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
              {/* <AiOutlinePlus size={25} /> */}
            </button>
            <button
              onClick={() => toggleFeatureModal(row)}
              className={"btn-k btn-muted-k dark-text small add-feature-btn"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-text-paragraph"
                viewBox="0 0 16 16"
                style={{
                  color: "#171717",
                  width: "25px",
                  height: "25px",
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
                />
              </svg>
            </button>
          </div>
        );
      },
    },
  ];

  const columns_goal_focus = [
    {
      dataField: "package_name",
      text: "Plan Name",
      formatter: (data) => {
        return <span className="flex-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "",
      text: "Mapped Plans",
      formatter: (_, row) => {
        return (
          <span
            onClick={() => toggleDescModal(row)}
            className="flex-k table-link-k fs-normal-k"
          >
            Open
          </span>
        );
      },
    },
    {
      dataField: "duration",
      text: "Duration",
      formatter: (_, row) => {
        const day = Number(row?.duration) > 1 ? "Days" : "Day";
        return <span className="flex-k">{`${row?.duration} ${day}`}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const isActive = row?.status === "active";
        return (
          <div className="flex-k">
            <span
              className={`badge fs-6 text-capitalize ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {row?.status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="flex-k gap-05-k">
            <button
              onClick={() => toggleEditModalGF(row)}
              className={"btn-k btn-muted-k dark-text small"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-pencil-fill"
                viewBox="0 0 16 16"
              >
                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
              </svg>
              {/* <BiSolidEdit size={25} /> */}
            </button>
            <button
              onClick={() => toggleMapModalGF(row)}
              className={"btn-k btn-muted-k dark-text small"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
              {/* <AiOutlinePlus size={25} /> */}
            </button>
          </div>
        );
      },
    },
  ];

  const mappedPlansCol = [
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (data) => {
        return <span className="flex-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "duration",
      text: "Duration",
      formatter: (data) => {
        return <span className="flex-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (data) => {
        return <span className="flex-k">{data || "N/A"}</span>;
      },
    },
    {
      dataField: "is_outdated",
      text: "Is Updated",
      formatter: (data) => {
        return (
          <span className="flex-k">
            {data === "false" ? "Yes" : "No" || "N/A"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="flex-k gap-05-k">
            <button
              onClick={() => setMapUpdateModal({ status: true, data: row })}
              disabled={row?.is_outdated === "false" || isLoadingUMap}
              className="btn-k btn-muted-k bold-text dark-text small"
            >
              Map
            </button>
            <button
              onClick={() => handleMappedPlanDelete(row?.uid)}
              disabled={isLoadingDltPlan}
              className="btn-k btn-primary-k small"
            >
              Delete
            </button>
            {/* <button
              onClick={() => toggleMapModal(row)}
              className={"btn-k btn-muted-k dark-text small"}
            >
              <AiOutlinePlus size={25} />
            </button> */}
          </div>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Plan Management">
      <div className="grid-k container-k gap-1">
        <div className="flex-k js-between-k items-end-k flex-wrap-k">
          <h1 className="fs-larger-k bold-text">Centralized Management</h1>
        </div>
        <div className="flex-k items-center-k js-start-k">
          <Tabs
            activeTab={activeTab}
            type="secondary"
            setActiveTab={setActiveTab}
            tabs={tabs}
          />
        </div>

        {activeTab === tabs[0] ? (
          <>
            <div className="overflow-auto">
              {isLoadingPl ||
              isFetchingPl ||
              isLoadingmapPl ||
              isFetchingmapPl ? (
                <div className="my-5 py-5 flex-k js-center-k items-center-k">
                  <Loader />
                </div>
              ) : (
                <>
                  <div className="grid-k grid-col-2-k p-1 gap-2">
                    {/* {activeTab === tabs[0] && ( */}
                    <div className="flex-k items-end-k gap-1">
                      <button
                        className={"btn-k btn-primary-k"}
                        onClick={toggleFormModal}
                      >
                        Add Plan
                      </button>
                      {/* <button
                        className={"btn-k btn-primary-k"}
                        onClick={() =>
                          onOpenModal("all_access_pass_categories")
                        }
                      >
                        Manage All Access Category
                      </button> */}
                    </div>
                    {/* )} */}
                    <div className="grid-k grid-col-2-k gap-05-k">
                      <div className="flex-k flex-col-k">
                        <label className="dark-text">Search</label>
                        <input
                          className="input-k grid-span-2-k"
                          type="text"
                          placeholder="Search By Name.."
                          value={search}
                          onChange={handleSearch}
                        />
                      </div>
                      <div className="flex-k js-center-k items-end-k gap-2">
                        <button
                          className="btn-k dark-bg-k w-full-k"
                          onClick={applySearch}
                        >
                          Search
                        </button>
                        <button
                          className="btn-k dark-bg-k w-full-k"
                          onClick={resetSearch}
                        >
                          Reset
                        </button>
                        <div className="flex-k w-full-k flex-col-k items-end-k">
                          <div className="flex-k js-start-k flex-col-k">
                            <label className="text-muted fs-smaller-k">
                              Rows:
                            </label>
                            <Select
                              options={Array.from({ length: 4 })
                                .fill(1)
                                .map((_, n) => ({
                                  label: (n + 1) * 5,
                                  value: (n + 1) * 5,
                                }))}
                              value={{
                                label: filters?.limit,
                                value: filters?.limit,
                              }}
                              onChange={(opt) =>
                                setFilters({ ...filters, limit: opt?.value })
                              }
                              placeholder="Rows"
                              classNamePrefix={"input-k-select small"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <CustomTable data={reOrder() || []} columns={columns} />
                  {!isdata() ? (
                    <div className="d-flex justify-content-center my-5">
                      <p className="fs-2">No data available!</p>
                    </div>
                  ) : null}
                </>
              )}
              <div className="w-full-k flex-k js-end-k p-1">
                <Pagination
                  isPage={isPage}
                  onChangePage={setIsPage}
                  isEmpty={isdata()}
                  pagination={getPagination()}
                />
              </div>
            </div>
          </>
        ) : null}

        <>
          {/* {activeTab === tabs[1] ? (
        <>
          <div className="overflow-auto">
            {isLoadingWP_GF || isFetchingWP_GF ? (
              <div className="my-5 py-5 flex-k js-center-k items-center-k">
                <Loader />
              </div>
            ) : (
              <>
                <CustomTable
                  data={wp_gf_data?.data || []}
                  columns={columns_goal_focus}
                />
                {!isdata() ? (
                  <div className="d-flex justify-content-center my-5">
                    <p className="fs-2">No data available!</p>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </>
      ) : null} */}
        </>

        {activeTab === tabs[1] ? (
          <>
            <Suspense fallback={<Loader />}>
              <Addon />
            </Suspense>
          </>
        ) : null}

        {activeTab === tabs[2] ? (
          <>
            <Suspense fallback={<Loader />}>
              <IncentiveModel />
            </Suspense>
          </>
        ) : null}

        {activeTab === tabs[3] ? (
          <>
            <Suspense fallback={<Loader />}>
              <Offers />
              {/* <COfferSystem /> */}
            </Suspense>
          </>
        ) : null}

        <Modal ariaHideApp={false} isOpen={isEditModalOpen}>
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            <div className={"modal-body-k bg-white rounded-5"}>
              <AddPlan
                refetch={refetchPlans}
                refetchMapAblePlans={refetchP}
                onClose={editModalToggle}
                currentPlan={currentPlan}
                isUpdate={true}
              />
            </div>
          </Suspense>
        </Modal>

        <Modal ariaHideApp={false} isOpen={formModal}>
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            <div className={"modal-body-k bg-white rounded-5"}>
              <AddPlan refetch={refetchPlans} onClose={toggleFormModal} />
            </div>
          </Suspense>
        </Modal>

        <Modal ariaHideApp={false} isOpen={isMapModalOpen}>
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            <div className={"modal-body-k bg-white rounded-5"}>
              <AddPlan
                refetch={refetchPlans}
                onClose={toggleMapModal}
                currentPlan={currentPlan}
                isMap={true}
                refetchMapAblePlans={refetchP}
                isGoalMap={activeTab === tabs[1] ? true : false}
              />
            </div>
          </Suspense>
        </Modal>

        <Modal
          // className={"modal-body-k bg-white rounded-5"}
          ariaHideApp={false}
          isOpen={isMapModalOpenGF}
        >
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            {isMapModalOpenGF ? (
              <div className={"modal-body-k bg-white rounded-5"}>
                <AddPlan
                  refetch={refetchPlans}
                  onClose={toggleMapModalGF}
                  currentPlan={currentPlan}
                  isMap={true}
                  isGoalMap={activeTab === tabs[1] ? true : false}
                />
              </div>
            ) : null}
          </Suspense>
        </Modal>

        <Modal
          // className={"modal-body-k bg-white rounded-5"}
          ariaHideApp={false}
          isOpen={isEditModalOpenGF}
        >
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            <div className={"modal-body-k bg-white rounded-5"}>
              <div>
                <div className="flex-k items-center-k js-between-k">
                  <h3 className="modal-title-k">Edit Plan</h3>
                  <button
                    type="button"
                    className="btn-k"
                    onClick={toggleEditModalGF}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                    {/* <AiOutlineClose size={25} /> */}
                  </button>
                </div>
                <div>
                  <GoalFocusForm
                    refetch={refetchGFPlans}
                    onClose={toggleEditModalGF}
                    initialValues={currentPlan}
                  />
                </div>
              </div>
            </div>
          </Suspense>
        </Modal>

        <Modal ariaHideApp={false} isOpen={descModal}>
          <div>
            {isFetchingGFPlDetail || isLoadingGFPlDetail || isLoadingDltPlan ? (
              <Loader />
            ) : (
              <div
                className={
                  "modal-body-k my-1-k gap-1-k small bg-white rounded-5"
                }
              >
                <ModalHeader title={"Mapped Plans"} onClick={toggleDescModal} />
                <div>
                  {isLoadingmapPl || isFetchingmapPl ? (
                    <div className="my-6-k">
                      <Loader />
                    </div>
                  ) : (
                    <CustomTable
                      data={getMappedGyms(currentPlan?.uid) || []}
                      columns={mappedPlansCol}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Modal>

        <Modal
          onRequestClose={() =>
            setMapUpdateModal({ status: false, data: null })
          }
          ariaHideApp={false}
          isOpen={mapUpdateModal?.status}
        >
          <div
            className={
              "modal-body-k my-1-k gap-1-k small container bg-white rounded-5"
            }
          >
            <ModalHeader
              title={"Plan Details"}
              onClick={() => setMapUpdateModal({ status: false, data: null })}
            />
            <div className="flex-k flex-col-k gap-2 my-3">
              <div className="flex-k p-2 border items-center-k js-between-k">
                <div className="flex-k flex-col-k">
                  <span className="fs-small-k bold-text">Plan Name</span>
                  <span>{currentPlan?.plan_name}</span>
                </div>
                <div>
                  <Icons size="20" name={"rightArrow"} />
                </div>
                <div className="flex-k items-end-k flex-col-k">
                  <span className="fs-small-k bold-text">Plan Name</span>
                  <span>{mapUpdateModal?.data?.plan_name}</span>
                </div>
              </div>
              <div className="flex-k p-2 border items-center-k js-between-k">
                <div className="flex-k flex-col-k">
                  <span className="fs-small-k bold-text">Duration</span>
                  <span>{currentPlan?.duration}</span>
                </div>
                <div>
                  <Icons size="20" name={"rightArrow"} />
                </div>
                <div className="flex-k items-end-k flex-col-k">
                  <span className="fs-small-k bold-text">Duration</span>
                  <span>{mapUpdateModal?.data?.duration}</span>
                </div>
              </div>
              <div className="flex-k p-2 border items-center-k js-between-k">
                <div className="flex-k flex-col-k">
                  <span className="fs-small-k bold-text">Price</span>
                  <span>
                    {currentPlan?.price
                      ? `₹ ${formatNumber(
                          Math.round(+currentPlan?.price / 1.18)
                        )}`
                      : "N/A"}
                  </span>
                </div>
                <div>
                  <Icons size="20" name={"rightArrow"} />
                </div>
                <div className="flex-k flex-col-k items-end-k">
                  <span className="fs-small-k bold-text">Price</span>
                  <span>
                    {mapUpdateModal?.data?.price
                      ? `₹ ${formatNumber(mapUpdateModal?.data?.price)}`
                      : "N/A"}
                  </span>
                </div>
              </div>
              <div className="flex-k p-2 border items-start-k js-between-k">
                <div className="flex-k gap-05-k flex-col-k">
                  <span className="fs-small-k bold-text">Selling Prices</span>
                  {currentPlan?.price_details &&
                    currentPlan?.price_details?.map((item) => (
                      <span key={item?.id}>
                        {item?.plan_price
                          ? `₹ ${formatNumber(item?.plan_price)}`
                          : "N/A"}
                      </span>
                    ))}
                </div>
                <div>
                  <Icons size="20" name={"rightArrow"} />
                </div>
                <div className="flex-k gap-05-k flex-col-k items-end-k">
                  <span className="fs-small-k bold-text">Selling Prices</span>
                  {mapUpdateModal?.data?.price_details &&
                    mapUpdateModal?.data?.price_details?.map((item) => (
                      <span key={item?.id}>
                        {item?.plan_price
                          ? `₹ ${formatNumber(item?.plan_price)}`
                          : "N/A"}
                      </span>
                    ))}
                </div>
              </div>
              <div className="flex-k js-center-k items-center-k">
                <button
                  disabled={isLoadingUMap}
                  onClick={() => handleMappedPlanUpdate(mapUpdateModal?.data)}
                  className="btn-k dark-bg-k"
                >
                  Map
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          ariaHideApp={false}
          isOpen={isFeatureModal}
          onRequestClose={() => {
            setIsFeatureModal(false);
            setRowData("");
          }}
        >
          <Suspense
            fallback={
              <div className="flex-k items-center-k vh-100">
                <Loader />
              </div>
            }
          >
            <div className={"modal-body-k bg-white rounded-5 autoHeightMax"}>
              <AddFeature
                onCloseModal={() => {
                  setIsFeatureModal(false);
                  setRowData("");
                }}
                rowData={rowData}
              />
            </div>
          </Suspense>
        </Modal>

        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "view_details" ? "mod-width-50p" : ""
            }`}
          >
            <ModalHeadAndClose
              title={
                modValues.modName === "view_details"
                  ? modValues.rowData?.plan_name || ""
                  : ""
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "view_details" ? (
              <DetailListings row={modValues.rowData} />
            ) : (
              <AllAccessCategories userInfoData={userInfoData} />
            )}
          </div>
        </Modal>
      </div>
    </HelmetWrapper>
  );
};

export default Plans;
